<template>
  <label id="switch-button" :class="classObject" :style="{ opacity: this.disabled ? 0.7 : 1, cursor: this.disabled ? 'not-allowed' : 'pointer' }">
    <input type="checkbox" :disabled="disabled" :style="{ cursor: this.disabled ? 'not-allowed' : 'pointer' }" v-model="value">
  </label>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    type: String,
    size: String,
    checked: Boolean
  },
  data () {
    return {
      value: false
    }
  },
  computed: {
    classObject () {
      const { type, size, value } = this
      return {
        [`is-${type}`]: type,
        [`is-${size}`]: size,
        checked: value
      }
    }
  },
  mounted () {
    this.value = this.checked
  },
  watch: {
    checked () {
      this.value = this.checked
    },
    value (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss">
$grey-lighter: hsl(0, 0%, 71%);
$switch-border: $grey-lighter;
$switch-colors: ("primary": (white, white));
$switch-text: #B4E04F;

#switch-button {
  margin-top: 2px;
  --height: 20px;
  --scale: 1.8;

  input {
    opacity: 0;
    display: inline-block;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    cursor: pointer;
  }

  appearance: none;
  position: relative;
  outline: 0;
  border: 1.2px solid #777777;
  border-radius: calc(0.8 * var(--height));
  width: calc(var(--scale) * var(--height));
  height: var(--height);
  background-color: $switch-border;
  cursor: pointer;
  box-sizing: border-box;
  display: inline-block;
  -webkit-tap-highlight-color: transparent;

  &:before,
  &:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    height: calc(var(--height) - 4px);
    border-radius: calc((var(--height) - 2px) / 2);
    transition: .233s;
  }

  &:before {
    width: calc(1.625 * var(--height) - 2px);
    background-color: $grey-lighter;
  }

  &:after {
    margin-top: -0.5px;
    border: 1.2px solid #777777;
    width: calc(var(--height) - 4px);
    background-color: #FFF;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1);
  }

  &.checked {
    background-color: $switch-text;
    &:before {
      transform: scale(0);
    }
    &:after {
      background: $switch-text;
      transform: translateX(calc((var(--scale) - 1) * var(--height)));
    }
  }

  // Colors
  @each $name, $pair in $switch-colors {
    $color: nth($pair, 1);
    &.is-#{$name} {
      &.checked {
        background-color: $color;
      }
    }
  }

  // Sizes
  &.is-small {
    --height: 16px
  }
  &.is-medium {
    --height: 27px
  }
  &.is-large {
    --height: 32px
  }
  &.is-long {
    --scale: 2
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/switchButton.vue